/**
 * All that survives of the Create React App PWA scaffold. The app is Vite now and never registered a
 * service worker, so `register()` and `service-worker.ts` were deleted; this call exists purely to tear
 * down a worker that an older build may still have installed in someone's browser.
 *
 * DO NOT delete this before roughly 2027-03-08. A browser holding a stale service worker serves its
 * cached bundle indefinitely, so removing the unregister call would pin those users to an old build with
 * no way to self-recover. Once no client can plausibly still be carrying one, delete this file and its
 * call in main.tsx.
 */
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
